/* Hallmark · component-scope · project tokens · critique P4 H4 E4 S5 R5 V3.
 * Missing, partial and complete readings stay distinct; no connection implies a measurement.
 */
import { Activity } from 'lucide-react';
import type { TelemetryData } from '../../hooks/useTelemetryStream';
import { formatEquipmentRating, summarizeEquipmentRating } from '../../utils/rackMetrics.logic';

interface LivingTwinOverlayProps {
  equipmentIds: string[];
  metrics: Record<string, TelemetryData>;
}

export function LivingTwinOverlay({ equipmentIds, metrics }: LivingTwinOverlayProps) {
  const readings = equipmentIds.map(id => metrics[id] ?? {});
  const power = summarizeEquipmentRating(readings, 'power_w');
  const temperatures = readings.map(reading => reading.temp_c).filter(
    (value): value is number => typeof value === 'number' && Number.isFinite(value),
  );
  return (
    <section aria-label="Телеметрия стойки" className="shrink-0 min-w-0 border-b border-border bg-bg-panel px-3 py-2 text-text-primary">
      <details>
      <summary className="min-h-11 cursor-pointer text-xs leading-relaxed focus-visible:outline-2 focus-visible:outline-accent">
        <Activity size={14} className="inline-block mr-2" aria-hidden />Полученные показания · {power.itemCount > power.unknownCount
          ? formatEquipmentRating(readings, 'power_w', 'Вт') : 'Нет показаний мощности'}
      </summary>
      <dl className="mt-3 space-y-2 text-xs">
        <div><dt className="text-text-secondary">Мощность</dt><dd className="mt-1 font-mono [overflow-wrap:anywhere]">{power.itemCount > power.unknownCount
          ? formatEquipmentRating(readings, 'power_w', 'Вт') : 'Нет показаний мощности'}</dd></div>
        <div><dt className="text-text-secondary">Максимальная температура</dt><dd className="mt-1 font-mono">{temperatures.length
          ? `${Math.max(...temperatures).toFixed(1)} °C · ${temperatures.length} из ${equipmentIds.length}` : 'Нет показаний температуры'}</dd></div>
      </dl>
      <p className="mt-3 text-[11px] leading-relaxed text-text-secondary">Давность самого измерения источник не передаёт. Отсутствие показаний не означает нулевую нагрузку.</p>
      </details>
    </section>
  );
}
